module.exports = __webpack_public_path__ + "static/media/web_form_submitted.ac7f50a8.svg";